import { render, staticRenderFns } from "./MatchingCourse.vue?vue&type=template&id=6b8176a0&scoped=true&"
import script from "./MatchingCourse.vue?vue&type=script&lang=js&"
export * from "./MatchingCourse.vue?vue&type=script&lang=js&"
import style0 from "./MatchingCourse.vue?vue&type=style&index=0&id=6b8176a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8176a0",
  null
  
)

export default component.exports